// There's 'npm pluralize' if we need something more complicated.

const pluralize = (word, count) => (count === 1 ? word : `${word}s`)

export { pluralize }
